// App
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';
import { useBlurbLinks } from 'app/shared/modules/MobileSRP/SeoFooter/useBlurbLinks';
import { useDynamicBlurb } from 'app/shared/modules/MobileSRP/SeoFooter/useDynamicBlurb';

export const useMobileLogic = () => {
  const area = useSelector((state: RootReduxState) => state.area.area);
  const totalListings = useSelector((state: RootReduxState) => state.listings.totalListings);
  const searchSlug = useSelector((state: RootReduxState) => state.filter.search.slug);
  const propertyTypes = useSelector((state: RootReduxState) => state.filter.propertyTypes);
  const isHouse =
    propertyTypes.house === true &&
    propertyTypes.any === false &&
    propertyTypes.apartment === false &&
    propertyTypes.condo === false &&
    propertyTypes.duplex === false &&
    propertyTypes.townhouse === false;

  const { name, resourceId, type } = area;
  const formattedNumberOfListings = totalListings.toLocaleString('en-US', { minimumFractionDigits: 0 });
  const houseOrApartment = isHouse ? 'house' : 'apartment';

  const [dynamicBlurb] = useDynamicBlurb({
    areaType: type,
    areaName: name,
    numberOfListings: formattedNumberOfListings,
    houseOrApartment,
  });

  const [blurbLinks] = useBlurbLinks({
    name,
    areaType: type,
    resourceId,
    searchSlug,
    houseOrApartment,
  });

  return [dynamicBlurb, blurbLinks, houseOrApartment];
};
